import React, { useState, Component } from 'react';
import { ArrowLeftIcon, MapPinIcon, EditIcon, CompassIcon, PackageIcon, TruckIcon, BarChart3Icon, BoxIcon, ClipboardListIcon, HistoryIcon, CalendarIcon, AlertCircleIcon, CheckCircleIcon, SearchIcon, FilterIcon, PlusIcon, DownloadIcon, RefreshCwIcon, ChevronDownIcon, ChevronRightIcon, SettingsIcon, UserIcon, ArrowRightIcon, PieChartIcon, EyeIcon, TrashIcon, XCircleIcon, InfoIcon, SlidersIcon, ArrowUpDownIcon, CheckIcon, ListFilterIcon, ShieldIcon, TrendingUpIcon, TrendingDownIcon, ThumbsUpIcon, ThumbsDownIcon, PercentIcon, PrinterIcon, ArchiveIcon, HelpCircleIcon, BellIcon, FileTextIcon, TagIcon, ZapIcon } from 'lucide-react';
export function WarehouseDetails({
  id = 'IU1',
  name = 'Pierce - San Antonio',
  location = '6203 Woodlake Center TEXAS San Antonio United States',
  flag = '🇺🇸',
  stock = '2%',
  machines = '7',
  onBack
}) {
  const [activeTab, setActiveTab] = useState('details');
  const [activeStockTab, setActiveStockTab] = useState('stockByDesign');
  const [stockFilter, setStockFilter] = useState('all');
  const [stockSort, setStockSort] = useState('name');
  const [showStockTemplateModal, setShowStockTemplateModal] = useState(false);
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  // Mock data for the warehouse details
  const warehouseData = {
    oracleCode: id,
    organizationId: '9946',
    name: location.split(' ').pop(),
    region: 'Aisco AMERICA',
    address: location,
    zipCode: '78244',
    coordinates: '29.485804, -98.360062'
  };
  // Mock data for machine stock
  const machineStockData = [{
    id: 'M001',
    name: '6" 5/8 GALV',
    type: 'Pivot Machine',
    desiredStock: 100,
    stats: {
      lowStock: 1,
      overStock: 90,
      covered: 7,
      orderRequired: 2
    },
    atHand: 0,
    incoming: 0,
    lastUpdated: '2023-10-15',
    status: 'Critical',
    priority: 'High',
    category: 'Irrigation',
    trend: 'decreasing',
    forecast: 'Needs restock within 7 days'
  }, {
    id: 'M002',
    name: '8" 5/8 GALV',
    type: 'Pivot Machine',
    desiredStock: 30,
    stats: {
      lowStock: 0,
      overStock: 80,
      covered: 20,
      orderRequired: 0
    },
    atHand: 7,
    incoming: 21,
    lastUpdated: '2023-10-18',
    status: 'Good',
    priority: 'Medium',
    category: 'Irrigation',
    trend: 'stable',
    forecast: 'Stock levels adequate for 30 days'
  }, {
    id: 'M003',
    name: '5" GALV',
    type: 'Pivot Machine',
    desiredStock: 20,
    stats: {
      lowStock: 4,
      overStock: 71,
      covered: 15,
      orderRequired: 10
    },
    atHand: 0,
    incoming: 5,
    lastUpdated: '2023-10-12',
    status: 'Warning',
    priority: 'Medium',
    category: 'Irrigation',
    trend: 'increasing',
    forecast: 'Incoming shipment will improve levels'
  }, {
    id: 'M004',
    name: 'High Profile',
    type: 'Pivot Machine',
    desiredStock: 20,
    stats: {
      lowStock: 0,
      overStock: 99,
      covered: 1,
      orderRequired: 0
    },
    atHand: 0,
    incoming: 0,
    lastUpdated: '2023-10-05',
    status: 'Critical',
    priority: 'Low',
    category: 'Specialized',
    trend: 'stable',
    forecast: 'Low demand, no immediate action needed'
  }, {
    id: 'M005',
    name: 'Linear',
    type: 'Linear',
    desiredStock: 15,
    stats: {
      lowStock: 17,
      overStock: 8,
      covered: 65,
      orderRequired: 10
    },
    atHand: 1,
    incoming: 0,
    lastUpdated: '2023-10-19',
    status: 'Warning',
    priority: 'High',
    category: 'Linear Systems',
    trend: 'decreasing',
    forecast: 'Order required within 14 days'
  }, {
    id: 'M006',
    name: 'Corner Arm',
    type: 'Pivot Accessory',
    desiredStock: 8,
    stats: {
      lowStock: 0,
      overStock: 0,
      covered: 100,
      orderRequired: 0
    },
    atHand: 8,
    incoming: 2,
    lastUpdated: '2023-10-17',
    status: 'Optimal',
    priority: 'Low',
    category: 'Accessories',
    trend: 'increasing',
    forecast: 'Stock levels optimal'
  }];
  // Consolidated stock data
  const consolidatedStock = {
    name: 'Stock Consolidated',
    stats: {
      lowStock: 2,
      overStock: 85,
      covered: 6,
      orderRequired: 7
    },
    percentage: '2%',
    atHand: 7,
    incoming: 21,
    trend: {
      weekly: '+2%',
      monthly: '-5%',
      quarterly: '+12%'
    },
    healthScore: 68,
    alertCount: 3,
    lastUpdated: '2023-10-20'
  };
  // Filter and sort machines based on current selections
  const getFilteredAndSortedMachines = () => {
    let filtered = [...machineStockData];
    // Apply filters
    if (stockFilter === 'critical') {
      filtered = filtered.filter(m => m.status === 'Critical');
    } else if (stockFilter === 'warning') {
      filtered = filtered.filter(m => m.status === 'Warning');
    } else if (stockFilter === 'good') {
      filtered = filtered.filter(m => m.status === 'Good' || m.status === 'Optimal');
    } else if (stockFilter === 'incoming') {
      filtered = filtered.filter(m => m.incoming > 0);
    } else if (stockFilter === 'nostock') {
      filtered = filtered.filter(m => m.atHand === 0);
    }
    // Apply sorting
    if (stockSort === 'name') {
      filtered.sort((a, b) => a.name.localeCompare(b.name));
    } else if (stockSort === 'priority') {
      const priorityOrder = {
        High: 0,
        Medium: 1,
        Low: 2
      };
      filtered.sort((a, b) => priorityOrder[a.priority] - priorityOrder[b.priority]);
    } else if (stockSort === 'status') {
      const statusOrder = {
        Critical: 0,
        Warning: 1,
        Good: 2,
        Optimal: 3
      };
      filtered.sort((a, b) => statusOrder[a.status] - statusOrder[b.status]);
    } else if (stockSort === 'stock') {
      filtered.sort((a, b) => b.atHand - a.atHand);
    }
    return filtered;
  };
  // Get status counts for summary
  const getStatusCounts = () => {
    const counts = {
      critical: machineStockData.filter(m => m.status === 'Critical').length,
      warning: machineStockData.filter(m => m.status === 'Warning').length,
      good: machineStockData.filter(m => m.status === 'Good').length,
      optimal: machineStockData.filter(m => m.status === 'Optimal').length
    };
    return counts;
  };
  const statusCounts = getStatusCounts();
  const filteredMachines = getFilteredAndSortedMachines();
  // Mock data for inventory
  const inventoryData = [{
    category: 'Irrigation Parts',
    items: [{
      id: 'IP001',
      name: 'Sprinkler Head Type A',
      quantity: 120,
      unit: 'pcs',
      status: 'Optimal'
    }, {
      id: 'IP002',
      name: 'Pipe Connector 2"',
      quantity: 85,
      unit: 'pcs',
      status: 'Optimal'
    }, {
      id: 'IP003',
      name: 'Valve System B',
      quantity: 12,
      unit: 'sets',
      status: 'Low'
    }]
  }, {
    category: 'Electronic Components',
    items: [{
      id: 'EC001',
      name: 'Control Board v2',
      quantity: 8,
      unit: 'pcs',
      status: 'Low'
    }, {
      id: 'EC002',
      name: 'Sensor Package',
      quantity: 24,
      unit: 'pcs',
      status: 'Optimal'
    }]
  }, {
    category: 'Structural Elements',
    items: [{
      id: 'SE001',
      name: 'Support Beam 4m',
      quantity: 0,
      unit: 'pcs',
      status: 'Out of Stock'
    }, {
      id: 'SE002',
      name: 'Tower Section',
      quantity: 6,
      unit: 'sets',
      status: 'Low'
    }]
  }];
  // Mock data for alterations
  const alterationsData = [{
    id: 'ALT001',
    date: '2023-10-20',
    type: 'Stock Update',
    description: 'Added 4 Control Panel Pro units',
    user: 'Maria Rodriguez'
  }, {
    id: 'ALT002',
    date: '2023-10-18',
    type: 'Inventory Adjustment',
    description: 'Corrected Sprinkler Head Type A count from 110 to 120',
    user: 'John Smith'
  }, {
    id: 'ALT003',
    date: '2023-10-15',
    type: 'Machine Removal',
    description: 'Removed 1 Linear System A for maintenance',
    user: 'David Chen'
  }, {
    id: 'ALT004',
    date: '2023-10-10',
    type: 'Address Update',
    description: 'Updated warehouse zip code',
    user: 'Sarah Johnson'
  }, {
    id: 'ALT005',
    date: '2023-10-05',
    type: 'Stock Update',
    description: 'Received new shipment of Sensor Packages (24 units)',
    user: 'Maria Rodriguez'
  }];
  return <div className="bg-gradient-to-r from-blue-950 via-indigo-900 to-teal-900 min-h-screen text-white" data-id="element-6574" data-mp="21s7vnwkgquu6">
      {/* Header with enhanced styling */}
      <div className="p-5 flex items-center bg-gradient-to-r from-blue-900/80 to-indigo-900/80 backdrop-blur-sm shadow-md" data-id="element-6575" data-mp="2pewkz3bsxpkt">
        <button onClick={onBack} className="mr-4 p-2 text-white bg-gradient-to-br from-white/20 to-white/5 hover:from-white/30 hover:to-white/10 rounded-full transition-all duration-300 shadow-lg" data-id="element-6576" data-mp="2fj2wclkt65mo">
          <ArrowLeftIcon size={20} data-id="element-6577" data-mp="142whtavu7gka" />
        </button>
        <div data-id="element-6578" data-mp="142375ytrc6wv">
          <div className="flex items-center" data-id="element-6579" data-mp="145r292eup1dp">
            <h1 className="text-2xl font-bold" data-id="element-6580" data-mp="193k63osoljat">{name}</h1>
            <span className="ml-2 text-2xl" data-id="element-6581" data-mp="1904s6paqugaz">{flag}</span>
          </div>
          <div className="flex items-center text-blue-100 text-sm mt-1" data-id="element-6582" data-mp="3n8fd0p15c7bq">
            <span className="bg-gradient-to-r from-blue-800/70 to-indigo-800/70 px-2 py-0.5 rounded-md" data-id="element-6583" data-mp="3ia454juew6w5">
              {id}
            </span>
            <span className="mx-2" data-id="element-6584" data-mp="37xnw0v7wtj">|</span>
            <MapPinIcon size={14} className="mr-1" data-id="element-6585" data-mp="3s93ey5qwy8kq" />
            <span data-id="element-6586" data-mp="3s78ustngukhp">{location}</span>
          </div>
        </div>
      </div>
      {/* Tabs with enhanced styling */}
      <div className="border-b border-indigo-800 bg-gradient-to-r from-blue-900/40 to-indigo-900/40 backdrop-blur-sm" data-id="element-6587" data-mp="2zko2nqz624d3">
        <div className="flex px-4" data-id="element-6588" data-mp="3dcm5jk2ab40t">
          <TabButton icon={<ClipboardListIcon size={18} data-id="element-6590" data-mp="3de6xr314mavi" />} label="Details" active={activeTab === 'details'} onClick={() => setActiveTab('details')} data-id="element-6589" data-mp="3ddndhfo07aeb" />
          <TabButton icon={<PackageIcon size={18} data-id="element-6592" data-mp="2kuzzslbc6xn9" />} label="Machine Stock" active={activeTab === 'machineStock'} onClick={() => setActiveTab('machineStock')} data-id="element-6591" data-mp="2kvjii48t9q2c" />
          <TabButton icon={<BoxIcon size={18} data-id="element-6594" data-mp="2gsdcmxpm20we" />} label="Inventory" active={activeTab === 'inventory'} onClick={() => setActiveTab('inventory')} data-id="element-6593" data-mp="2gty063dicjkr" />
          <TabButton icon={<HistoryIcon size={18} data-id="element-6596" data-mp="1yop18543f3mj" />} label="Alterations" active={activeTab === 'alterations'} onClick={() => setActiveTab('alterations')} data-id="element-6595" data-mp="1yn490m593wru" />
        </div>
      </div>
      {/* Content with improved spacing */}
      <div className="p-6 md:p-8" data-id="element-6597" data-mp="1pm5zjoc1mx1v">
        {activeTab === 'details' && <div className="bg-gradient-to-br from-white to-blue-50 text-gray-800 rounded-xl shadow-2xl overflow-hidden transition-all duration-500" data-id="element-6598" data-mp="1knl1nvk9kpgl">
            <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-blue-100 via-indigo-50 to-white" data-id="element-6599" data-mp="1fvl7kjqvkqrx">
              <h2 className="text-xl font-bold flex items-center text-indigo-800" data-id="element-6600" data-mp="1avyse4rhl0gh">
                <ClipboardListIcon size={22} className="mr-3 text-indigo-600" data-id="element-6601" data-mp="16y1371xpued3" />
                Warehouse Details
              </h2>
            </div>
            <div className="p-6 md:p-8" data-id="element-6602" data-mp="wyjzur5xscka">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-6603" data-mp="wysbkfqbpbtw">
                <div className="space-y-6" data-id="element-6604" data-mp="38mf1meat7clh">
                  <DetailRow icon={<BoxIcon size={18} className="text-indigo-600" data-id="element-6606" data-mp="38nzttx9nijg6" />} label="Oracle Code:" value={warehouseData.oracleCode} data-id="element-6605" data-mp="38ldlvwium1xf" />
                  <DetailRow icon={<BarChart3Icon size={18} className="text-indigo-600" data-id="element-6608" data-mp="3ijjmmasx520p" />} label="Organization ID:" value={warehouseData.organizationId} data-id="element-6607" data-mp="3ij9yksrfp4xn" />
                  <DetailRow icon={<MapPinIcon size={18} className="text-indigo-600" data-id="element-6610" data-mp="3mj293b0e1l5n" />} label="Name:" value={warehouseData.name} data-id="element-6609" data-mp="3mklo6yab5q5u" />
                  <DetailRow icon={<TruckIcon size={18} className="text-indigo-600" data-id="element-6612" data-mp="2utpaxwkc5ji1" />} label="Region:" value={warehouseData.region} data-id="element-6611" data-mp="2utz5zyk8mgul" />
                </div>
                <div className="space-y-6" data-id="element-6613" data-mp="2yu97axx34j34">
                  <DetailRow icon={<MapPinIcon size={18} className="text-indigo-600" data-id="element-6615" data-mp="33mso03r2juc5" />} label="Address:" value={warehouseData.address} data-id="element-6614" data-mp="33majyky60bto" />
                  <DetailRow icon={<MapPinIcon size={18} className="text-indigo-600" data-id="element-6617" data-mp="274e90br91j2b" />} label="Zip Code:" value={warehouseData.zipCode} data-id="element-6616" data-mp="273v17nvbcb20" />
                  <DetailRow icon={<CompassIcon size={18} className="text-indigo-600" data-id="element-6619" data-mp="3egvs8nutw3ou" />} label="Coordinates:" value={warehouseData.coordinates} data-id="element-6618" data-mp="2b3vf97ei2k8j" />
                </div>
              </div>
              {/* Map placeholder with improved styling */}
              <div className="mt-8 bg-gradient-to-b from-blue-50 via-indigo-50 to-gray-50 rounded-xl p-6 h-64 flex items-center justify-center shadow-inner" data-id="element-6620" data-mp="3o5x6a8htcb06">
                <div className="text-center" data-id="element-6621" data-mp="2vi9pz5nks6jc">
                  <div className="bg-gradient-to-br from-white to-blue-50 p-4 rounded-full shadow-md inline-block mb-4" data-id="element-6622" data-mp="2vjcitj4gkj1w">
                    <CompassIcon size={40} className="text-indigo-500" data-id="element-6623" data-mp="2ql1712ulryh1" />
                  </div>
                  <p className="text-gray-600 font-medium" data-id="element-6624" data-mp="34kiwlkfq3frg">
                    Interactive map would be displayed here
                  </p>
                  <p className="text-sm text-gray-500 mt-2 flex items-center justify-center" data-id="element-6625" data-mp="jsgtydmkypds">
                    <MapPinIcon size={14} className="mr-1" data-id="element-6626" data-mp="fr5ayqy7p2ek" />
                    {warehouseData.coordinates}
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-r from-gray-50 to-blue-50 px-8 py-5 flex justify-end" data-id="element-6627" data-mp="nd0tupd65qoh">
              <button className="flex items-center text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 px-5 py-2.5 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg" data-id="element-6628" data-mp="s7ek6dcz57ma">
                <EditIcon size={16} className="mr-2" data-id="element-6629" data-mp="160mbe3x5813g" />
                Edit Warehouse Details
              </button>
            </div>
          </div>}
        {activeTab === 'machineStock' && <div className="bg-gradient-to-br from-white to-blue-50 text-gray-800 rounded-xl shadow-2xl overflow-hidden transition-all duration-500" data-id="element-6630" data-mp="wbcgkgax04bn">
            {/* Sub-tabs navigation with improved styling */}
            <div className="border-b border-gray-200 bg-gradient-to-r from-blue-100 via-indigo-50 to-white" data-id="element-6631" data-mp="1p09yujf4m14e">
              <div className="flex" data-id="element-6632" data-mp="1tr9t1gwv2537">
                <StockTabButton label="Stock By Design" active={activeStockTab === 'stockByDesign'} onClick={() => setActiveStockTab('stockByDesign')} data-id="element-6633" data-mp="1tsb6tt59h5om" />
                <StockTabButton label="Stock in transit" active={activeStockTab === 'stockInTransit'} onClick={() => setActiveStockTab('stockInTransit')} data-id="element-6634" data-mp="12spfvtgsi4n" />
                <button className="px-5 py-3.5 text-gray-600 hover:text-gray-800 flex items-center transition-colors" data-id="element-6635" data-mp="3s9vd4da3g6a4">
                  <SettingsIcon size={16} className="mr-2" data-id="element-6636" data-mp="3ncwk5y2625di" />
                  Settings
                </button>
              </div>
            </div>
            {activeStockTab === 'stockByDesign' && <>
                {/* Enhanced dashboard header with improved styling */}
                <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-white to-blue-50" data-id="element-6637" data-mp="f1a5d7d4oqc0">
                  <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-6638" data-mp="a1xnl11469ga">
                    <div data-id="element-6639" data-mp="17lh7ifllukfx">
                      <h2 className="text-xl font-bold text-gray-800 flex items-center" data-id="element-6640" data-mp="12sxtjhj09nal">
                        <PackageIcon size={22} className="mr-2 text-indigo-600" data-id="element-6641" data-mp="1b1bnmgh5w69l" />
                        Machine Stock Management
                      </h2>
                      <p className="text-gray-600 mt-1" data-id="element-6642" data-mp="1f3fby5oxj5ca">
                        Monitor and manage machine stock levels across your
                        warehouse
                      </p>
                    </div>
                    <div className="flex flex-wrap gap-3" data-id="element-6643" data-mp="1oz07pm3en9dl">
                      <button className="flex items-center text-gray-700 border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-100 transition-all shadow-sm" onClick={() => setShowFilterPanel(!showFilterPanel)} data-id="element-6644" data-mp="1tz4qjirscg6z">
                        <FilterIcon size={16} className="mr-2" data-id="element-6645" data-mp="22tsxregx87yf" />
                        Filter
                        <span className={`ml-1 flex items-center justify-center h-5 w-5 text-xs rounded-full ${stockFilter !== 'all' ? 'bg-indigo-100 text-indigo-700' : 'bg-gray-100 text-gray-500'}`} data-id="element-6646" data-mp="27q9jy34k8c8v">
                          {stockFilter !== 'all' ? '1' : '0'}
                        </span>
                      </button>
                      <div className="relative group" data-id="element-6647" data-mp="1rziiwzosbakr">
                        <button className="flex items-center text-gray-700 border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-100 transition-all shadow-sm" data-id="element-6648" data-mp="1n3bcl5sh7x2a">
                          <ArrowUpDownIcon size={16} className="mr-2" data-id="element-6649" data-mp="1x0pqoyqxg9rf" />
                          Sort By
                          <ChevronDownIcon size={16} className="ml-2" data-id="element-6650" data-mp="2aruixfrytzrq" />
                        </button>
                        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-10" data-id="element-6651" data-mp="25t9s26ylssfy">
                          <div className="py-1" data-id="element-6652" data-mp="2fqnz5fyn04vl">
                            <SortOption label="Name" active={stockSort === 'name'} onClick={() => setStockSort('name')} data-id="element-6653" data-mp="2fryzt6wscwih" />
                            <SortOption label="Priority" active={stockSort === 'priority'} onClick={() => setStockSort('priority')} data-id="element-6654" data-mp="qe3y2hq9yo7v" />
                            <SortOption label="Status" active={stockSort === 'status'} onClick={() => setStockSort('status')} data-id="element-6655" data-mp="2x09osp7xdakz" />
                            <SortOption label="Stock Level" active={stockSort === 'stock'} onClick={() => setStockSort('stock')} data-id="element-6656" data-mp="31z348n6rvbns" />
                          </div>
                        </div>
                      </div>
                      <button className="flex items-center text-white bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 px-4 py-2 rounded-lg transition-all shadow-md hover:shadow-lg" onClick={() => setShowStockTemplateModal(true)} data-id="element-6657" data-mp="2s7qcdvkz4lhr">
                        <PlusIcon size={16} className="mr-2" data-id="element-6658" data-mp="24cvy38utlb9b" />
                        Create Template
                      </button>
                      <button className="flex items-center text-gray-700 border border-gray-300 px-3 py-2 rounded-lg hover:bg-gray-100 transition-all shadow-sm" data-id="element-6659" data-mp="29d1l2bq5a9l2">
                        <DownloadIcon size={16} data-id="element-6660" data-mp="7ij4b94k6wb8" />
                      </button>
                      <button className="flex items-center text-gray-700 border border-gray-300 px-3 py-2 rounded-lg hover:bg-gray-100 transition-all shadow-sm" data-id="element-6661" data-mp="2qin6l6kfwdvr">
                        <PrinterIcon size={16} data-id="element-6662" data-mp="2miw62b542je1" />
                      </button>
                    </div>
                  </div>
                  {/* Filter panel */}
                  {showFilterPanel && <div className="mt-4 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-100 animate-fadeIn" data-id="element-6663" data-mp="2cqgq1jddk4vs">
                      <div className="flex items-center justify-between mb-3" data-id="element-6664" data-mp="22s17i4sey3xw">
                        <h3 className="font-medium text-indigo-800 flex items-center" data-id="element-6665" data-mp="1yqxrniad87wo">
                          <ListFilterIcon size={16} className="mr-2" data-id="element-6666" data-mp="1yssej2576a3e" />
                          Filter Machine Stock
                        </h3>
                        <button className="text-gray-500 hover:text-gray-700" onClick={() => setShowFilterPanel(false)} data-id="element-6667" data-mp="3t58ifwaitc53">
                          <XCircleIcon size={18} data-id="element-6668" data-mp="3o6f27w3un718" />
                        </button>
                      </div>
                      <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-id="element-6669" data-mp="3vp4si5ayybao">
                        <FilterButton label="All Machines" active={stockFilter === 'all'} onClick={() => setStockFilter('all')} count={machineStockData.length} data-id="element-6670" data-mp="4hsn0njg7mal" />
                        <FilterButton label="Critical Stock" active={stockFilter === 'critical'} onClick={() => setStockFilter('critical')} count={statusCounts.critical} color="red" data-id="element-6671" data-mp="e8n83okykfug" />
                        <FilterButton label="Warning Stock" active={stockFilter === 'warning'} onClick={() => setStockFilter('warning')} count={statusCounts.warning} color="amber" data-id="element-6672" data-mp="3csvf7k7w5orq" />
                        <FilterButton label="Good Stock" active={stockFilter === 'good'} onClick={() => setStockFilter('good')} count={statusCounts.good + statusCounts.optimal} color="green" data-id="element-6673" data-mp="3mqt50c5eftmg" />
                        <FilterButton label="Incoming" active={stockFilter === 'incoming'} onClick={() => setStockFilter('incoming')} count={machineStockData.filter(m => m.incoming > 0).length} color="blue" data-id="element-6674" data-mp="11y7w4lvyy3al" />
                        <FilterButton label="No Stock" active={stockFilter === 'nostock'} onClick={() => setStockFilter('nostock')} count={machineStockData.filter(m => m.atHand === 0).length} color="gray" data-id="element-6675" data-mp="16vp7on5i2pcu" />
                      </div>
                    </div>}
                </div>
                {/* Summary cards row */}
                <div className="p-6 grid grid-cols-1 md:grid-cols-4 gap-4 bg-gradient-to-br from-white to-blue-50" data-id="element-6676" data-mp="nyxjq0f0jm2g">
                  <div className="bg-gradient-to-br from-indigo-50 to-blue-100 rounded-xl p-4 border border-blue-200 shadow-md" data-id="element-6677" data-mp="rzziyh8xjy4f">
                    <div className="flex items-center justify-between" data-id="element-6678" data-mp="wyud2fccl93u">
                      <div data-id="element-6679" data-mp="11yyty6h645ul">
                        <p className="text-sm font-medium text-indigo-800" data-id="element-6680" data-mp="1209wk2yvn7k4">
                          Overall Stock Health
                        </p>
                        <h3 className="mt-1 text-2xl font-bold text-indigo-900" data-id="element-6681" data-mp="2ddls7qkhgjv7">
                          {consolidatedStock.healthScore}
                          <span className="text-sm font-normal text-indigo-700" data-id="element-6682" data-mp="1p784lm1stfg">
                            /100
                          </span>
                        </h3>
                      </div>
                      <div className="h-12 w-12 bg-gradient-to-br from-indigo-400 to-blue-500 rounded-full flex items-center justify-center shadow-md" data-id="element-6683" data-mp="3o4s6xddxi7gb">
                        <ShieldIcon size={24} className="text-white" data-id="element-6684" data-mp="3f556att0x5ob" />
                      </div>
                    </div>
                    <div className="mt-3 flex items-center text-sm" data-id="element-6685" data-mp="3a629txr407ry">
                      <span className={`flex items-center ${consolidatedStock.trend.weekly.startsWith('+') ? 'text-green-700' : 'text-red-700'}`} data-id="element-6686" data-mp="3578z2d37iuvh">
                        {consolidatedStock.trend.weekly.startsWith('+') ? <TrendingUpIcon size={14} className="mr-1" data-id="element-6687" data-mp="13fvrfg9uu8vq" /> : <TrendingDownIcon size={14} className="mr-1" data-id="element-6688" data-mp="13ekr5qfmbj9d" />}
                        {consolidatedStock.trend.weekly} this week
                      </span>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-red-50 to-rose-100 rounded-xl p-4 border border-red-200 shadow-md" data-id="element-6689" data-mp="2svet5akeu4z7">
                    <div className="flex items-center justify-between" data-id="element-6690" data-mp="2xpj6cbk9r98q">
                      <div data-id="element-6691" data-mp="2j0myofm4jy8n">
                        <p className="text-sm font-medium text-red-800" data-id="element-6692" data-mp="2nxwk7k6e7pr7">
                          Critical Stock
                        </p>
                        <h3 className="mt-1 text-2xl font-bold text-red-900" data-id="element-6693" data-mp="3bois9bgeda17">
                          {statusCounts.critical}
                        </h3>
                      </div>
                      <div className="h-12 w-12 bg-gradient-to-br from-red-400 to-rose-500 rounded-full flex items-center justify-center shadow-md" data-id="element-6694" data-mp="32ncbr2dqzz7y">
                        <AlertCircleIcon size={24} className="text-white" data-id="element-6695" data-mp="36ml5464vlv2z" />
                      </div>
                    </div>
                    <div className="mt-3 flex items-center text-sm text-red-800" data-id="element-6696" data-mp="1v992tzorlkix">
                      <ThumbsDownIcon size={14} className="mr-1" data-id="element-6697" data-mp="1v6wf15wbsfxy" />
                      Needs immediate attention
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-green-50 to-emerald-100 rounded-xl p-4 border border-green-200 shadow-md" data-id="element-6698" data-mp="1ipu0mmy95ta7">
                    <div className="flex items-center justify-between" data-id="element-6699" data-mp="1xljq4v2ncojo">
                      <div data-id="element-6700" data-mp="1spcgar74qswg">
                        <p className="text-sm font-medium text-green-800" data-id="element-6701" data-mp="1smyqawrb46vr">
                          Optimal Stock
                        </p>
                        <h3 className="mt-1 text-2xl font-bold text-green-900" data-id="element-6702" data-mp="100x7wnii78u3">
                          {statusCounts.optimal}
                        </h3>
                      </div>
                      <div className="h-12 w-12 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full flex items-center justify-center shadow-md" data-id="element-6703" data-mp="19xs0kps3if0g">
                        <CheckCircleIcon size={24} className="text-white" data-id="element-6704" data-mp="m6mn2h9mnytb" />
                      </div>
                    </div>
                    <div className="mt-3 flex items-center text-sm text-green-800" data-id="element-6705" data-mp="3gnn7lrqmpk6b">
                      <ThumbsUpIcon size={14} className="mr-1" data-id="element-6706" data-mp="3glu2whzkta0y" />
                      Well-stocked machines
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-amber-50 to-yellow-100 rounded-xl p-4 border border-amber-200 shadow-md" data-id="element-6707" data-mp="3pnjsrjdt80wm">
                    <div className="flex items-center justify-between" data-id="element-6708" data-mp="3uh4unmiixf13">
                      <div data-id="element-6709" data-mp="388u380ouaf6">
                        <p className="text-sm font-medium text-amber-800" data-id="element-6710" data-mp="3b3eizjpbv8l">
                          Incoming Shipments
                        </p>
                        <h3 className="mt-1 text-2xl font-bold text-amber-900" data-id="element-6711" data-mp="c96wxmze4bw6">
                          {machineStockData.filter(m => m.incoming > 0).length}
                        </h3>
                      </div>
                      <div className="h-12 w-12 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center shadow-md" data-id="element-6712" data-mp="2e23ii3qxewuj">
                        <TruckIcon size={24} className="text-white" data-id="element-6713" data-mp="2bg3wzlq5v1r7" />
                      </div>
                    </div>
                    <div className="mt-3 flex items-center text-sm text-amber-800" data-id="element-6714" data-mp="26pdqg5600sux">
                      <CalendarIcon size={14} className="mr-1" data-id="element-6715" data-mp="21q16bs6ihzw1" />
                      Next arrival: 3 days
                    </div>
                  </div>
                </div>
                {/* Consolidated stock card - enhanced */}
                <div className="px-6 pt-2 pb-6 bg-gradient-to-br from-white to-blue-50" data-id="element-6716" data-mp="2udx30ww2zrst">
                  <div className="bg-gradient-to-br from-white via-blue-50 to-indigo-100 border border-blue-200 rounded-xl overflow-hidden shadow-lg" data-id="element-6717" data-mp="2ph6i9w9c0812">
                    <div className="p-5 border-b border-blue-100" data-id="element-6718" data-mp="2gfgv52mhfv93">
                      <div className="flex justify-between items-start" data-id="element-6719" data-mp="2gf7379hvne0r">
                        <div data-id="element-6720" data-mp="192y8l29ntt6u">
                          <div className="flex items-center" data-id="element-6721" data-mp="19383935ngoiv">
                            <h3 className="font-bold text-xl text-indigo-800" data-id="element-6722" data-mp="14z8ooq3xjzs5">
                              {consolidatedStock.name}
                            </h3>
                            <span className="ml-3 bg-gradient-to-r from-blue-100 to-indigo-100 text-indigo-700 text-xs px-2.5 py-0.5 rounded-full" data-id="element-6723" data-mp="1bgk0u0sq4b0a">
                              Last updated: {consolidatedStock.lastUpdated}
                            </span>
                          </div>
                          <p className="text-gray-600 mt-1" data-id="element-6724" data-mp="nqzdz6tg8tlq">
                            Comprehensive overview of all machine stock in this
                            warehouse
                          </p>
                        </div>
                        <div className="bg-gradient-to-br from-blue-100 to-indigo-200 p-2 rounded-full" data-id="element-6725" data-mp="dtl09eywuix4">
                          <PieChartIcon size={24} className="text-indigo-600" data-id="element-6726" data-mp="isxuwlw0wua9" />
                        </div>
                      </div>
                      <div className="mt-5 grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-6727" data-mp="4u7y77d48wmf">
                        <div className="bg-gradient-to-br from-white to-gray-50 rounded-lg p-4 border border-gray-100 shadow-sm" data-id="element-6728" data-mp="8t6wwa897x5f">
                          <div className="flex items-center justify-between" data-id="element-6729" data-mp="3hbphfep8aink">
                            <div data-id="element-6730" data-mp="3hdshkrk3hs60">
                              <p className="text-sm font-medium text-gray-500" data-id="element-6731" data-mp="3vb8rid1lo42i">
                                Total Machines
                              </p>
                              <h4 className="mt-1 text-xl font-bold text-gray-800" data-id="element-6732" data-mp="3qb2vyls7lxf5">
                                {machineStockData.length}
                              </h4>
                            </div>
                            <div className="h-10 w-10 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center" data-id="element-6733" data-mp="4335j2lbjb73">
                              <PackageIcon size={20} className="text-gray-700" data-id="element-6734" data-mp="duqtuumkwc4c" />
                            </div>
                          </div>
                        </div>
                        <div className="bg-gradient-to-br from-white to-gray-50 rounded-lg p-4 border border-gray-100 shadow-sm" data-id="element-6735" data-mp="mvxcpacp9z0r">
                          <div className="flex items-center justify-between" data-id="element-6736" data-mp="1u730qsciguek">
                            <div data-id="element-6737" data-mp="1y96nid4mrlf5">
                              <p className="text-sm font-medium text-gray-500" data-id="element-6738" data-mp="1y850rbe95ahl">
                                Machines at Hand
                              </p>
                              <h4 className="mt-1 text-xl font-bold text-indigo-700" data-id="element-6739" data-mp="288fdyw0aehwr">
                                {consolidatedStock.atHand}
                              </h4>
                            </div>
                            <div className="h-10 w-10 bg-gradient-to-br from-indigo-100 to-blue-200 rounded-full flex items-center justify-center" data-id="element-6740" data-mp="1figiahrl7mj4">
                              <BoxIcon size={20} className="text-indigo-700" data-id="element-6741" data-mp="1kg8f9q739yu6" />
                            </div>
                          </div>
                        </div>
                        <div className="bg-gradient-to-br from-white to-gray-50 rounded-lg p-4 border border-gray-100 shadow-sm" data-id="element-6742" data-mp="rt4fbzmusap9">
                          <div className="flex items-center justify-between" data-id="element-6743" data-mp="wqe031zary6r">
                            <div data-id="element-6744" data-mp="p8g665tlmvon">
                              <p className="text-sm font-medium text-gray-500" data-id="element-6745" data-mp="ka4tzofu0939">
                                Incoming Machines
                              </p>
                              <h4 className="mt-1 text-xl font-bold text-teal-600" data-id="element-6746" data-mp="f9756t0bggss">
                                {consolidatedStock.incoming}
                              </h4>
                            </div>
                            <div className="h-10 w-10 bg-gradient-to-br from-teal-100 to-green-200 rounded-full flex items-center justify-center" data-id="element-6747" data-mp="6cg8cedxwxx5">
                              <TruckIcon size={20} className="text-teal-700" data-id="element-6748" data-mp="3sp55p7url54t" />
                            </div>
                          </div>
                        </div>
                        <div className="bg-gradient-to-br from-white to-gray-50 rounded-lg p-4 border border-gray-100 shadow-sm" data-id="element-6749" data-mp="3irilc5up4ldg">
                          <div className="flex items-center justify-between" data-id="element-6750" data-mp="3er839utmq4i8">
                            <div data-id="element-6751" data-mp="1eq8pv41n90af">
                              <p className="text-sm font-medium text-gray-500" data-id="element-6752" data-mp="1epgx00zflgnu">
                                Alerts
                              </p>
                              <h4 className="mt-1 text-xl font-bold text-amber-600" data-id="element-6753" data-mp="1nr6laxy0nzhe">
                                {consolidatedStock.alertCount}
                              </h4>
                            </div>
                            <div className="h-10 w-10 bg-gradient-to-br from-amber-100 to-orange-200 rounded-full flex items-center justify-center" data-id="element-6754" data-mp="vzqx4zgta4p2">
                              <BellIcon size={20} className="text-amber-700" data-id="element-6755" data-mp="qz2z3tu60nlc" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p-5" data-id="element-6756" data-mp="cc9rzbusuo48">
                      <div className="flex justify-between items-start mb-6" data-id="element-6757" data-mp="cb88cizpwtaw">
                        <div className="space-y-4 w-full max-w-md" data-id="element-6758" data-mp="8b7pmm5l5vy1">
                          <h4 className="font-medium text-gray-800" data-id="element-6759" data-mp="88v9meje1vnm">
                            Stock Distribution
                          </h4>
                          <div className="space-y-3" data-id="element-6760" data-mp="2yj3udah12p4">
                            <StockStatItemEnhanced color="yellow" label="Low Stock" value={`${consolidatedStock.stats.lowStock}%`} icon={<AlertCircleIcon size={14} data-id="element-6762" data-mp="3pcss8meeiapw" />} data-id="element-6761" data-mp="3kdzf4v310lq9" />
                            <StockStatItemEnhanced color="orange" label="Over Stock" value={`${consolidatedStock.stats.overStock}%`} icon={<PercentIcon size={14} data-id="element-6764" data-mp="gv62cki2o0x5" />} data-id="element-6763" data-mp="3pdby34qs18nk" />
                            <StockStatItemEnhanced color="green" label="Covered" value={`${consolidatedStock.stats.covered}%`} icon={<CheckIcon size={14} data-id="element-6766" data-mp="6y1hqp3vkdig" />} data-id="element-6765" data-mp="lvaksg2jj5q0" />
                            <StockStatItemEnhanced color="red" label="Order Required" value={`${consolidatedStock.stats.orderRequired}%`} icon={<ShoppingCartIcon size={14} className="text-indigo-600" data-id="element-6768" data-mp="2rosglw3knw50" />} data-id="element-6767" data-mp="by5vi7deeu4z" />
                          </div>
                        </div>
                        <div className="text-center" data-id="element-6769" data-mp="2wpojq7g3ne9d">
                          <div className="relative" data-id="element-6770" data-mp="13661vvo6eld2">
                            <div className="w-32 h-32 rounded-full flex items-center justify-center bg-gradient-to-br from-blue-100 to-indigo-200 border-4 border-indigo-200 shadow-md" data-id="element-6771" data-mp="137qx7nibe8bz">
                              <div className="text-center" data-id="element-6772" data-mp="tea0obqsmf4m">
                                <span className="text-4xl font-bold text-indigo-800" data-id="element-6773" data-mp="ohjow0m0u5p0">
                                  {consolidatedStock.percentage}
                                </span>
                                <p className="text-xs font-medium text-indigo-600 mt-1" data-id="element-6774" data-mp="ffk7v8b0b1m2">
                                  Overall Stock
                                </p>
                              </div>
                            </div>
                            <div className="absolute -bottom-2 -right-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white text-xs px-2.5 py-1 rounded-full shadow-md" data-id="element-6775" data-mp="5jgvl9mfxmle">
                              <ZapIcon size={14} className="inline mr-1" data-id="element-6776" data-mp="1zvne6thnz5nq" />
                              Status
                            </div>
                          </div>
                          <div className="mt-4 grid grid-cols-3 gap-2 text-xs" data-id="element-6777" data-mp="2ce9dxhg92tk4">
                            <div className="bg-gradient-to-r from-blue-50 to-indigo-100 rounded-lg p-2" data-id="element-6778" data-mp="2cc6g4b8uvw4u">
                              <div className="font-medium text-indigo-800" data-id="element-6779" data-mp="2m4cdy1lsh7ry">
                                Weekly
                              </div>
                              <div className={`font-bold ${consolidatedStock.trend.weekly.startsWith('+') ? 'text-green-600' : 'text-red-600'}`} data-id="element-6780" data-mp="1ohvhszosl07s">
                                {consolidatedStock.trend.weekly}
                              </div>
                            </div>
                            <div className="bg-gradient-to-r from-blue-50 to-indigo-100 rounded-lg p-2" data-id="element-6781" data-mp="23e4ebthaszgi">
                              <div className="font-medium text-indigo-800" data-id="element-6782" data-mp="39svdnsqrwc8f">
                                Monthly
                              </div>
                              <div className={`font-bold ${consolidatedStock.trend.monthly.startsWith('+') ? 'text-green-600' : 'text-red-600'}`} data-id="element-6783" data-mp="3euudisnb0r0m">
                                {consolidatedStock.trend.monthly}
                              </div>
                            </div>
                            <div className="bg-gradient-to-r from-blue-50 to-indigo-100 rounded-lg p-2" data-id="element-6784" data-mp="3mafuxr60kbd2">
                              <div className="font-medium text-indigo-800" data-id="element-6785" data-mp="3hfilwk8qi206">
                                Quarterly
                              </div>
                              <div className={`font-bold ${consolidatedStock.trend.quarterly.startsWith('+') ? 'text-green-600' : 'text-red-600'}`} data-id="element-6786" data-mp="3rakexr64ro81">
                                {consolidatedStock.trend.quarterly}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="border-t border-blue-100 p-3 bg-gradient-to-r from-blue-50 to-indigo-50 flex justify-between items-center" data-id="element-6787" data-mp="dxs52vzym9tu">
                      <button className="text-indigo-600 hover:text-indigo-800 hover:bg-white/50 font-medium flex items-center py-2 px-4 rounded-lg transition-colors" data-id="element-6788" data-mp="xgelp6datxe2">
                        <FileTextIcon size={16} className="mr-2" data-id="element-6789" data-mp="njjocqsri31d" />
                        Generate Report
                      </button>
                      <div className="flex space-x-2" data-id="element-6790" data-mp="sl8ze6fzigpg">
                        <button className="text-indigo-600 hover:text-indigo-800 hover:bg-white/50 font-medium flex items-center py-2 px-4 rounded-lg transition-colors" data-id="element-6791" data-mp="dtqafj55dbty">
                          <EyeIcon size={16} className="mr-2" data-id="element-6792" data-mp="4ud9xfz03xld" />
                          View Details
                        </button>
                        <button className="text-gray-600 hover:text-gray-800 hover:bg-white/50 font-medium flex items-center py-2 px-4 rounded-lg transition-colors" data-id="element-6793" data-mp="9tg4u7l9onfm">
                          <SettingsIcon size={16} className="mr-2" data-id="element-6794" data-mp="3w0o894cmmk90" />
                          Configure
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Machine stock cards - enhanced grid */}
                <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 bg-gradient-to-br from-white to-blue-50" data-id="element-6795" data-mp="3356t1lu475l4">
                  {filteredMachines.map(machine => <MachineStockCard key={machine.id} machine={machine} data-id="element-6796" data-mp="2y4iw6jj7fuiz" />)}
                </div>
                {/* Pagination */}
                <div className="p-6 border-t border-gray-200 bg-gradient-to-r from-gray-50 to-blue-50 flex justify-between items-center" data-id="element-6797" data-mp="3qureqchnkgy3">
                  <div className="text-sm text-gray-600" data-id="element-6798" data-mp="3lumviepd1846">
                    Showing{' '}
                    <span className="font-medium" data-id="element-6799" data-mp="3gwbnm9iml7ol">
                      {filteredMachines.length}
                    </span>{' '}
                    of{' '}
                    <span className="font-medium" data-id="element-6800" data-mp="25i7s2ywe3bhf">
                      {machineStockData.length}
                    </span>{' '}
                    machines
                  </div>
                  <div className="flex space-x-1" data-id="element-6801" data-mp="ky2rw32qudgx">
                    <button className="px-3 py-1 border border-gray-300 rounded-md text-gray-600 hover:bg-white" data-id="element-6802" data-mp="pzs2jhm20p4h">
                      &laquo;
                    </button>
                    <button className="px-3 py-1 border border-gray-300 rounded-md bg-indigo-100 text-indigo-700 font-medium" data-id="element-6803" data-mp="zpbmyrpf0r1g">
                      1
                    </button>
                    <button className="px-3 py-1 border border-gray-300 rounded-md text-gray-600 hover:bg-white" data-id="element-6804" data-mp="18phulwyfmwsp">
                      &raquo;
                    </button>
                  </div>
                </div>
              </>}
            {activeStockTab === 'stockInTransit' && <div className="p-8 flex items-center justify-center" data-id="element-6805" data-mp="1imw93r0spbid">
                <div className="text-center" data-id="element-6806" data-mp="3fh98q7dqmkod">
                  <TruckIcon size={48} className="mx-auto text-indigo-400 mb-4" data-id="element-6807" data-mp="3fiahg57a6v2x" />
                  <h3 className="text-xl font-medium text-gray-800 mb-2" data-id="element-6808" data-mp="3kh50n895ulnk">
                    Stock in Transit
                  </h3>
                  <p className="text-gray-600" data-id="element-6809" data-mp="1l8dg1wb165oz">
                    This section will show machines that are currently in
                    transit to this warehouse.
                  </p>
                </div>
              </div>}
            {/* Create Stock Template Modal */}
            {showStockTemplateModal && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-id="element-6810" data-mp="177sy12cxwdwj">
                <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 animate-fadeIn" data-id="element-6811" data-mp="129rgilv5wmn6">
                  <div className="p-5 border-b border-gray-200 flex justify-between items-center bg-gradient-to-r from-blue-50 to-indigo-50" data-id="element-6812" data-mp="1h71qtrw2jmhb">
                    <h3 className="text-lg font-bold text-gray-800 flex items-center" data-id="element-6813" data-mp="1c5uk7w5nwtc8">
                      <PlusIcon size={18} className="mr-2 text-indigo-600" data-id="element-6814" data-mp="2skchk72wp38z" />
                      Create Stock Template
                    </h3>
                    <button className="text-gray-500 hover:text-gray-700" onClick={() => setShowStockTemplateModal(false)} data-id="element-6815" data-mp="2v63h87pkmioz">
                      <XCircleIcon size={20} data-id="element-6816" data-mp="305pxkq0p4f20" />
                    </button>
                  </div>
                  <div className="p-5" data-id="element-6817" data-mp="2m5xb56w7ckzu">
                    <div className="mb-4" data-id="element-6818" data-mp="2m78bewqfvam7">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-6819" data-mp="2q6quro2m3dmx">
                        Template Name
                      </label>
                      <input type="text" placeholder="Enter template name..." className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" data-id="element-6820" data-mp="3dxd3ziocr3yi" />
                    </div>
                    <div className="mb-4" data-id="element-6821" data-mp="395mm8rn35dx2">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-6822" data-mp="394bksyh44i94">
                        Description
                      </label>
                      <textarea placeholder="Enter template description..." rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" data-id="element-6823" data-mp="5gjfs3c4kth1"></textarea>
                    </div>
                    <div className="mb-4" data-id="element-6824" data-mp="1a29spnww3q95">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-6825" data-mp="v7lpkgeyp3wp">
                        Machine Type
                      </label>
                      <select className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" data-id="element-6826" data-mp="1089fszvd9gpv">
                        <option data-id="element-6827" data-mp="1stj4k3u4ur3w">Pivot Machine</option>
                        <option data-id="element-6828" data-mp="1e5y4kisk1807">Linear</option>
                        <option data-id="element-6829" data-mp="1e56h5v942gl0">Pivot Accessory</option>
                      </select>
                    </div>
                    <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-6830" data-mp="1j3g97wzjh12e">
                      <div data-id="element-6831" data-mp="26udbei1j8k0g">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-6832" data-mp="26t2dgyurq6h9">
                          Desired Stock
                        </label>
                        <input type="number" placeholder="0" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" data-id="element-6833" data-mp="5tlpqm301ai" />
                      </div>
                      <div data-id="element-6834" data-mp="9vmtshn0lya0">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-6835" data-mp="9xz9sp97pykf">
                          Priority
                        </label>
                        <select className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" data-id="element-6836" data-mp="3ddy2j9f2f0kn">
                          <option data-id="element-6837" data-mp="3me2wohv902gv">High</option>
                          <option data-id="element-6838" data-mp="3mew4zn9uv014">Medium</option>
                          <option data-id="element-6839" data-mp="3ibgbv0wzvht6">Low</option>
                        </select>
                      </div>
                    </div>
                    <div className="mb-4" data-id="element-6840" data-mp="11m11tx8ckgdr">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-6841" data-mp="11p6oz6xf186u">
                        Tags
                      </label>
                      <div className="flex flex-wrap gap-2 p-2 border border-gray-300 rounded-lg" data-id="element-6842" data-mp="3qf5zmo2blxz3">
                        <div className="bg-indigo-100 text-indigo-800 px-2 py-1 rounded-md text-sm flex items-center" data-id="element-6843" data-mp="3ve96me1v2e9p">
                          Irrigation
                          <XCircleIcon size={14} className="ml-1 cursor-pointer" data-id="element-6844" data-mp="8am682beve49" />
                        </div>
                        <input type="text" placeholder="Add tag..." className="flex-1 border-0 focus:outline-none text-sm" data-id="element-6845" data-mp="37pznxkzy26ms" />
                      </div>
                    </div>
                  </div>
                  <div className="p-5 border-t border-gray-200 flex justify-end gap-3 bg-gradient-to-r from-gray-50 to-blue-50" data-id="element-6846" data-mp="3gqnz87xydsvz">
                    <button className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-100" onClick={() => setShowStockTemplateModal(false)} data-id="element-6847" data-mp="3li606vzz7tgy">
                      Cancel
                    </button>
                    <button className="px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white rounded-lg shadow-md" onClick={() => setShowStockTemplateModal(false)} data-id="element-6848" data-mp="2sz0jmm656490">
                      Create Template
                    </button>
                  </div>
                </div>
              </div>}
          </div>}
        {activeTab === 'inventory' && <div className="bg-gradient-to-br from-white to-blue-50 text-gray-800 rounded-xl shadow-2xl overflow-hidden transition-all duration-500" data-id="element-6849" data-mp="27h1a14firprd">
            <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-blue-100 via-indigo-50 to-white" data-id="element-6850" data-mp="1xrzutggstceg">
              <h2 className="text-xl font-bold flex items-center text-indigo-800" data-id="element-6851" data-mp="1srvebqfw4ho8">
                <BoxIcon size={22} className="mr-3 text-indigo-600" data-id="element-6852" data-mp="1orbj4sevno4q" />
                Inventory Management
              </h2>
              <p className="text-gray-500 mt-1" data-id="element-6853" data-mp="1jqx7l0e2hw1y">
                View and manage all inventory items in this warehouse
              </p>
            </div>
            {/* Toolbar with improved styling */}
            <div className="bg-gradient-to-r from-gray-50 to-blue-50 p-5 border-b border-gray-100 flex flex-wrap items-center justify-between gap-4" data-id="element-6854" data-mp="3ew6d2hjsx3vw">
              <div className="relative" data-id="element-6855" data-mp="3jw16arr1u5k4">
                <input type="text" placeholder="Search inventory..." className="pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 w-64 shadow-sm" data-id="element-6856" data-mp="354adt35zb7q3" />
                <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-6857" data-mp="2w3c72d45om3t" />
              </div>
              <div className="flex gap-3" data-id="element-6858" data-mp="2m6fyk7e9bzz9">
                <button className="flex items-center text-gray-700 border border-gray-300 px-4 py-2.5 rounded-lg hover:bg-gray-100 transition-all shadow-sm" data-id="element-6859" data-mp="2m7rawvlrqg1z">
                  <FilterIcon size={16} className="mr-2" data-id="element-6860" data-mp="kfckt992m5ah" />
                  Filter
                </button>
                <button className="flex items-center text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 px-4 py-2.5 rounded-lg transition-all shadow-md hover:shadow-lg" data-id="element-6861" data-mp="pephsmtnosqs">
                  <PlusIcon size={16} className="mr-2" data-id="element-6862" data-mp="24xwx2yawqim3" />
                  Add Item
                </button>
              </div>
            </div>
            {/* Inventory categories with improved styling */}
            <div className="p-6 md:p-8 space-y-6" data-id="element-6863" data-mp="2eu9w8bp81oo8">
              {inventoryData.map((category, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-all duration-300" data-id="element-6864" data-mp="2slwswcn2sz7j" data-mpi={index}>
                  <div className="bg-gradient-to-r from-gray-50 to-blue-50 px-5 py-3.5 flex justify-between items-center cursor-pointer hover:bg-gradient-to-r hover:from-gray-100 hover:to-blue-100" data-id="element-6865" data-mp="2npzeibvdi2xe">
                    <h3 className="font-medium text-gray-800 flex items-center" data-id="element-6866" data-mp="2xjyep5bvzcmp">
                      <BoxIcon size={18} className="mr-2 text-indigo-600" data-id="element-6867" data-mp="1874n8iekhmsr" />
                      {category.category}
                    </h3>
                    <ChevronDownIcon size={20} className="text-gray-500" data-id="element-6868" data-mp="1sw70g3841b29" />
                  </div>
                  <div className="overflow-x-auto" data-id="element-6869" data-mp="1wx8wycan790j">
                    <table className="w-full" data-id="element-6870" data-mp="1wxsie2zi4fjb">
                      <thead className="bg-gradient-to-r from-gray-50 to-indigo-50" data-id="element-6871" data-mp="21w2dyep51i5g">
                        <tr data-id="element-6872" data-mp="26vorkp8vp0es">
                          <th className="px-6 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6873" data-mp="26vyfm7ad4xhu">
                            ID
                          </th>
                          <th className="px-6 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6874" data-mp="2fvuyttdzh45i">
                            Item Name
                          </th>
                          <th className="px-6 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6875" data-mp="2plwmwl6c6mkf">
                            Quantity
                          </th>
                          <th className="px-6 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6876" data-mp="2zk43h2wpr2lw">
                            Unit
                          </th>
                          <th className="px-6 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6877" data-mp="ixxfe5kczzll">
                            Status
                          </th>
                          <th className="px-6 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6878" data-mp="e0nsoxocu21g">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white" data-id="element-6879" data-mp="11pgh892nd7m1">
                        {category.items.map(item => <tr key={item.id} className="hover:bg-blue-50 transition-colors" data-id="element-6880" data-mp="wwne1pmtu7c2">
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-6881" data-mp="rxkicvsqldgr">
                              {item.id}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-6882" data-mp="1kmrg3skd9z0y">
                              {item.name}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 font-medium" data-id="element-6883" data-mp="sxvg2hrixwiq">
                              {item.quantity}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-6884" data-mp="jwx9brppbawg">
                              {item.unit}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap" data-id="element-6885" data-mp="1cp0h3b6geblg">
                              <StatusBadge status={item.status} data-id="element-6886" data-mp="1gpsqq5j8mii9" />
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm" data-id="element-6887" data-mp="12q181rhs0dxx">
                              <button className="text-indigo-600 hover:text-indigo-800 mr-3 font-medium" data-id="element-6888" data-mp="17omalxki39pj">
                                Edit
                              </button>
                              <button className="text-indigo-600 hover:text-indigo-800 font-medium" data-id="element-6889" data-mp="3ni3b2zetz6c4">
                                History
                              </button>
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>
                </div>)}
            </div>
            {/* Summary cards with improved styling */}
            <div className="px-8 pb-8 grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-6890" data-mp="3oww7s04x0qh7">
              <div className="bg-gradient-to-br from-blue-50 via-blue-100 to-indigo-100 border border-blue-200 rounded-xl p-5 shadow-md hover:shadow-lg transition-all duration-300" data-id="element-6891" data-mp="3out7mna1tgyr">
                <div className="flex items-center justify-between mb-3" data-id="element-6892" data-mp="2x7kr0tktictw">
                  <h4 className="text-indigo-800 font-medium" data-id="element-6893" data-mp="3ay6aaje6oosb">Total Items</h4>
                  <div className="bg-gradient-to-br from-blue-200 to-indigo-300 p-1.5 rounded-full" data-id="element-6894" data-mp="365wdcjeniogj">
                    <BoxIcon size={18} className="text-indigo-700" data-id="element-6895" data-mp="2igbxi9dso7bh" />
                  </div>
                </div>
                <p className="text-4xl font-bold text-indigo-700 mt-2" data-id="element-6896" data-mp="2dgphxtahuezi">267</p>
                <p className="text-indigo-600 text-sm mt-1 flex items-center" data-id="element-6897" data-mp="1bi9nl9sathrc">
                  <InfoIcon size={14} className="mr-1" data-id="element-6898" data-mp="16qzzidmeemhk" />
                  Across all categories
                </p>
              </div>
              <div className="bg-gradient-to-br from-amber-50 via-amber-100 to-orange-100 border border-amber-200 rounded-xl p-5 shadow-md hover:shadow-lg transition-all duration-300" data-id="element-6899" data-mp="11r56a3f5hktc">
                <div className="flex items-center justify-between mb-3" data-id="element-6900" data-mp="1uh41kgjxue6g">
                  <h4 className="text-amber-800 font-medium" data-id="element-6901" data-mp="1phhqacno780a">
                    Low Stock Items
                  </h4>
                  <div className="bg-gradient-to-br from-amber-200 to-orange-300 p-1.5 rounded-full" data-id="element-6902" data-mp="1lfec3g9m9pbb">
                    <AlertCircleIcon size={18} className="text-amber-700" data-id="element-6903" data-mp="1ghciw2ih89m4" />
                  </div>
                </div>
                <p className="text-4xl font-bold text-amber-700 mt-2" data-id="element-6904" data-mp="a1sagvmklv8w">14</p>
                <p className="text-amber-600 text-sm mt-1 flex items-center" data-id="element-6905" data-mp="514mkitn1uiw">
                  <InfoIcon size={14} className="mr-1" data-id="element-6906" data-mp="2gozsmi5jngpw" />
                  Require attention
                </p>
              </div>
              <div className="bg-gradient-to-br from-red-50 via-red-100 to-rose-100 border border-red-200 rounded-xl p-5 shadow-md hover:shadow-lg transition-all duration-300" data-id="element-6907" data-mp="2lnb38v3nxv96">
                <div className="flex items-center justify-between mb-3" data-id="element-6908" data-mp="2ug5yqx3bwclr">
                  <h4 className="text-red-800 font-medium" data-id="element-6909" data-mp="2ui8wy4emxc1k">Out of Stock</h4>
                  <div className="bg-gradient-to-br from-red-200 to-rose-300 p-1.5 rounded-full" data-id="element-6910" data-mp="2zez9wiv57rir">
                    <XCircleIcon size={18} className="text-red-700" data-id="element-6911" data-mp="34d0uj887vywc" />
                  </div>
                </div>
                <p className="text-4xl font-bold text-red-700 mt-2" data-id="element-6912" data-mp="39bkgv9qq3cp8">3</p>
                <p className="text-red-600 text-sm mt-1 flex items-center" data-id="element-6913" data-mp="3ddz2u2pouskq">
                  <InfoIcon size={14} className="mr-1" data-id="element-6914" data-mp="1f0fjuoa55yiv" />
                  Need immediate reorder
                </p>
              </div>
            </div>
          </div>}
        {activeTab === 'alterations' && <div className="bg-gradient-to-br from-white to-blue-50 text-gray-800 rounded-xl shadow-2xl overflow-hidden transition-all duration-500" data-id="element-6915" data-mp="2mbd9k8320blo">
            <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-blue-100 via-indigo-50 to-white" data-id="element-6916" data-mp="2hf6dr84dgghg">
              <h2 className="text-xl font-bold flex items-center text-indigo-800" data-id="element-6917" data-mp="2vai99hqcqazf">
                <HistoryIcon size={22} className="mr-3 text-indigo-600" data-id="element-6918" data-mp="2rdcehmefzgkq" />
                Alterations History
              </h2>
              <p className="text-gray-500 mt-1" data-id="element-6919" data-mp="30c7hyqq3qckc">
                Track all changes and updates made to this warehouse
              </p>
            </div>
            {/* Toolbar with improved styling */}
            <div className="bg-gradient-to-r from-gray-50 to-blue-50 p-5 border-b border-gray-100 flex flex-wrap items-center justify-between gap-4" data-id="element-6920" data-mp="3a1zie1kvtzwq">
              <div className="relative" data-id="element-6921" data-mp="3o21xjg1t2f8a">
                <input type="text" placeholder="Search alterations..." className="pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 w-64 shadow-sm" data-id="element-6922" data-mp="3j2p8congow2j" />
                <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-6923" data-mp="bgv1tx8naaq0" />
              </div>
              <div className="flex gap-3" data-id="element-6924" data-mp="3tplum0hdkex8">
                <button className="flex items-center text-gray-700 border border-gray-300 px-4 py-2.5 rounded-lg hover:bg-gray-100 transition-all shadow-sm" data-id="element-6925" data-mp="1j75j2ve4v5q">
                  <FilterIcon size={16} className="mr-2" data-id="element-6926" data-mp="3jvmxjfw5rlc5" />
                  Filter
                </button>
                <button className="flex items-center text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 px-4 py-2.5 rounded-lg transition-all shadow-md hover:shadow-lg" data-id="element-6927" data-mp="3oq9ahnhw1lyc">
                  <DownloadIcon size={16} className="mr-2" data-id="element-6928" data-mp="30z3th507onmg" />
                  Export History
                </button>
              </div>
            </div>
            {/* Timeline with improved styling */}
            <div className="p-6 md:p-8" data-id="element-6929" data-mp="2xwzc92mj4tip">
              <div className="space-y-8" data-id="element-6930" data-mp="2xwqyz9mhvm6z">
                {alterationsData.map((alteration, index) => <div key={alteration.id} className="flex" data-id="element-6931" data-mp="2sz7cjmfn833y" data-mpi={index}>
                    <div className="relative" data-id="element-6932" data-mp="2o77fq2uvdqbl">
                      <div className="flex-shrink-0 w-12 h-12 rounded-full bg-gradient-to-br from-blue-100 to-indigo-200 flex items-center justify-center shadow-md z-10 relative" data-id="element-6933" data-mp="2o5wby31fcikh">
                        <HistoryIcon size={22} className="text-indigo-600" data-id="element-6934" data-mp="2f7sp93epdfr3" />
                      </div>
                      {index < alterationsData.length - 1 && <div className="absolute top-12 bottom-0 left-1/2 w-0.5 bg-gradient-to-b from-indigo-200 to-blue-100 -ml-px h-full" data-id="element-6935" data-mp="2a9r8ip4r1sis"></div>}
                    </div>
                    <div className="ml-6 flex-1 bg-gradient-to-br from-white to-blue-50 rounded-xl border border-gray-100 shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden" data-id="element-6936" data-mp="218b5x3k6eup4">
                      <div className="p-5 border-b border-gray-50" data-id="element-6937" data-mp="3vmc6ptzadrru">
                        <div className="flex items-center justify-between" data-id="element-6938" data-mp="1hdrqts8zf3ej">
                          <h3 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-6939" data-mp="1mccs7uzyzt4k">
                            {alteration.type}
                            <span className="ml-3 bg-gradient-to-r from-blue-100 to-indigo-100 text-indigo-700 text-xs px-2.5 py-0.5 rounded-full" data-id="element-6940" data-mp="1r44ali8z2sjm">
                              #{alteration.id}
                            </span>
                          </h3>
                          <div className="flex items-center text-sm text-gray-500 bg-gradient-to-r from-gray-50 to-blue-50 px-3 py-1 rounded-full" data-id="element-6941" data-mp="13dh0cqbl3qtw">
                            <CalendarIcon size={14} className="mr-1.5" data-id="element-6942" data-mp="17eao9jp115ms" />
                            {alteration.date}
                          </div>
                        </div>
                        <p className="mt-3 text-gray-600" data-id="element-6943" data-mp="2iv0kc9zqkh2o">
                          {alteration.description}
                        </p>
                        <div className="mt-4 flex items-center text-sm text-gray-500 bg-gradient-to-r from-gray-50 to-blue-50 inline-block px-3 py-1 rounded-full" data-id="element-6944" data-mp="2nrhb7bybl9jg">
                          <UserIcon size={14} className="mr-1.5" data-id="element-6945" data-mp="jofoum77um00" />
                          By: {alteration.user}
                        </div>
                      </div>
                      <div className="px-5 py-2.5 bg-gradient-to-r from-gray-50 to-blue-50 flex justify-end" data-id="element-6946" data-mp="sqf7tk1sk05l">
                        <button className="text-indigo-600 hover:text-indigo-800 text-sm font-medium flex items-center" data-id="element-6947" data-mp="501qangu1jp9">
                          View Details
                          <ArrowRightIcon size={14} className="ml-1" data-id="element-6948" data-mp="3w4t4ga5olb5u" />
                        </button>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
            {/* Load more with improved styling */}
            <div className="bg-gradient-to-r from-gray-50 to-blue-50 px-8 py-5 text-center border-t border-gray-100" data-id="element-6949" data-mp="3ie6f38lt8xmf">
              <button className="text-indigo-600 hover:text-indigo-800 font-medium flex items-center justify-center mx-auto bg-gradient-to-r from-white to-blue-50 px-5 py-2.5 rounded-lg border border-blue-200 shadow-sm hover:shadow-md transition-all" data-id="element-6950" data-mp="3dg4l3smujdw6">
                <RefreshCwIcon size={16} className="mr-2" data-id="element-6951" data-mp="1jy79w4uihue3" />
                Load More History
              </button>
            </div>
          </div>}
      </div>
    </div>;
}
// Helper component for tab buttons
function TabButton({
  icon,
  label,
  active,
  onClick
}) {
  return <button className={`px-6 py-3.5 font-medium flex items-center transition-all duration-300 ${active ? 'border-b-2 border-white text-white' : 'text-gray-300 hover:text-white hover:bg-white/5'}`} onClick={onClick} data-id="element-6952" data-mp="2gny4s56ptjkf">
      {icon && <span className="mr-2" data-id="element-6953" data-mp="27mqgmfxwxz42">{icon}</span>}
      {label}
    </button>;
}
// Helper component for stock tab buttons
function StockTabButton({
  label,
  active,
  onClick
}) {
  return <button className={`px-6 py-3.5 font-medium transition-all duration-300 ${active ? 'border-b-2 border-indigo-500 text-indigo-600 bg-gradient-to-r from-blue-50 to-indigo-50' : 'text-gray-600 hover:text-gray-800 hover:bg-gradient-to-r hover:from-gray-50 hover:to-blue-50'}`} onClick={onClick} data-id="element-6954" data-mp="w8353u5l7oli">
      {label}
    </button>;
}
// Helper component for detail rows
function DetailRow({
  icon,
  label,
  value
}) {
  return <div className="flex border-b border-gray-100 pb-4 hover:bg-gradient-to-r hover:from-gray-50 hover:to-blue-50 p-2 rounded-lg transition-colors" data-id="element-6955" data-mp="18yx5v6yflrsa">
      <div className="w-48 font-medium flex items-center text-gray-700" data-id="element-6956" data-mp="26lcnq9ursrgd">
        {icon && <span className="mr-2" data-id="element-6957" data-mp="21nkuncie2zal">{icon}</span>}
        {typeof label === 'string' ? label : label}
      </div>
      <div className="flex-1 font-medium text-gray-900" data-id="element-6958" data-mp="1wuhxyvibf9q6">{value}</div>
    </div>;
}
// Helper component for status badges
function StatusBadge({
  status
}) {
  let config = {
    color: 'gray',
    icon: null
  };
  if (status === 'In Stock' || status === 'Optimal') {
    config = {
      color: 'green',
      icon: <CheckCircleIcon size={14} className="mr-1" data-id="element-6959" data-mp="2kju5lqxzv9qd" />
    };
  } else if (status === 'Low Stock' || status === 'Low') {
    config = {
      color: 'amber',
      icon: <AlertCircleIcon size={14} className="mr-1" data-id="element-6960" data-mp="2wx7kdz04b8ee" />
    };
  } else if (status === 'Out of Stock') {
    config = {
      color: 'red',
      icon: <XCircleIcon size={14} className="mr-1" data-id="element-6961" data-mp="31xlvjpx0mygn" />
    };
  }
  const gradients = {
    green: 'bg-gradient-to-r from-green-100 to-emerald-100',
    amber: 'bg-gradient-to-r from-amber-100 to-yellow-100',
    red: 'bg-gradient-to-r from-red-100 to-rose-100',
    gray: 'bg-gradient-to-r from-gray-100 to-slate-100'
  };
  const textColors = {
    green: 'text-green-800',
    amber: 'text-amber-800',
    red: 'text-red-800',
    gray: 'text-gray-800'
  };
  return <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${gradients[config.color]} ${textColors[config.color]}`} data-id="element-6962" data-mp="3pjsf99fsy2mp">
      {config.icon}
      {status}
    </span>;
}
// Helper component for stock stat items with colored dots
function StockStatItem({
  color,
  label
}) {
  const colors = {
    yellow: 'bg-gradient-to-r from-yellow-500 to-amber-500',
    orange: 'bg-gradient-to-r from-orange-500 to-amber-600',
    green: 'bg-gradient-to-r from-green-500 to-emerald-500',
    red: 'bg-gradient-to-r from-red-500 to-rose-500'
  };
  return <div className="flex items-center" data-id="element-6963" data-mp="1fvqyvvustzrn">
      <div className={`h-3 w-3 rounded-full ${colors[color]} mr-2.5 shadow-sm`} data-id="element-6964" data-mp="1fxk9tncg365g"></div>
      <span className="text-sm font-medium text-gray-700" data-id="element-6965" data-mp="1ku28c5h6m89c">{label}</span>
    </div>;
}
// Enhanced version of StockStatItem with value and icon
function StockStatItemEnhanced({
  color,
  label,
  value,
  icon
}) {
  const colors = {
    yellow: {
      dot: 'bg-gradient-to-r from-yellow-500 to-amber-500',
      text: 'text-amber-700',
      bg: 'bg-gradient-to-r from-yellow-50 to-amber-100'
    },
    orange: {
      dot: 'bg-gradient-to-r from-orange-500 to-amber-600',
      text: 'text-amber-700',
      bg: 'bg-gradient-to-r from-orange-50 to-amber-100'
    },
    green: {
      dot: 'bg-gradient-to-r from-green-500 to-emerald-500',
      text: 'text-green-700',
      bg: 'bg-gradient-to-r from-green-50 to-emerald-100'
    },
    red: {
      dot: 'bg-gradient-to-r from-red-500 to-rose-500',
      text: 'text-red-700',
      bg: 'bg-gradient-to-r from-red-50 to-rose-100'
    }
  };
  const colorConfig = colors[color];
  return <div className={`flex items-center justify-between py-2 px-3 rounded-lg ${colorConfig.bg}`} data-id="element-6966" data-mp="3f50s73ws2mf1">
      <div className="flex items-center" data-id="element-6967" data-mp="fpwyx4dn5t03">
        <div className={`h-3 w-3 rounded-full ${colorConfig.dot} mr-2.5 shadow-sm`} data-id="element-6968" data-mp="blz1cy3ysq95"></div>
        <span className="text-sm font-medium text-gray-800" data-id="element-6969" data-mp="6uz4ttyrca76">{label}</span>
      </div>
      <div className={`flex items-center ${colorConfig.text} font-medium`} data-id="element-6970" data-mp="1wfhbp4imqcp">
        {icon && <span className="mr-1" data-id="element-6971" data-mp="1ul652j1qclt">{icon}</span>}
        {value}
      </div>
    </div>;
}
// Helper component for stock progress bars
function StockProgressBar({
  label,
  value,
  color
}) {
  const colors = {
    yellow: {
      bg: 'bg-gradient-to-r from-yellow-50 to-amber-100',
      fill: 'bg-gradient-to-r from-yellow-400 to-amber-500',
      text: 'text-amber-800'
    },
    orange: {
      bg: 'bg-gradient-to-r from-orange-50 to-amber-100',
      fill: 'bg-gradient-to-r from-orange-400 to-amber-500',
      text: 'text-orange-800'
    },
    green: {
      bg: 'bg-gradient-to-r from-green-50 to-emerald-100',
      fill: 'bg-gradient-to-r from-green-400 to-emerald-500',
      text: 'text-green-800'
    },
    red: {
      bg: 'bg-gradient-to-r from-red-50 to-rose-100',
      fill: 'bg-gradient-to-r from-red-400 to-rose-500',
      text: 'text-red-800'
    }
  };
  const colorConfig = colors[color];
  return <div className="space-y-1" data-id="element-6972" data-mp="prhgu9f9wlfg">
      <div className="flex justify-between items-center" data-id="element-6973" data-mp="pssk884t3r61">
        <span className="text-xs font-medium text-gray-700" data-id="element-6974" data-mp="2g46wb6ijljfs">{label}</span>
        <span className={`text-xs font-medium ${colorConfig.text}`} data-id="element-6975" data-mp="2g22l03ibdi5h">
          {value}%
        </span>
      </div>
      <div className={`w-full h-2 ${colorConfig.bg} rounded-full overflow-hidden`} data-id="element-6976" data-mp="2k3fqudleplce">
        <div className={`h-full ${colorConfig.fill} rounded-full`} style={{
        width: `${value}%`
      }} data-id="element-6977" data-mp="8gc9r68leymp"></div>
      </div>
    </div>;
}
// Helper component for filter buttons
function FilterButton({
  label,
  active,
  onClick,
  count,
  color = 'indigo'
}) {
  const colors = {
    indigo: {
      activeBg: 'bg-gradient-to-r from-indigo-500 to-blue-600',
      activeText: 'text-white',
      inactiveBg: 'bg-white hover:bg-indigo-50',
      inactiveText: 'text-gray-700 hover:text-indigo-700',
      countBg: 'bg-indigo-100',
      countText: 'text-indigo-800'
    },
    red: {
      activeBg: 'bg-gradient-to-r from-red-500 to-rose-600',
      activeText: 'text-white',
      inactiveBg: 'bg-white hover:bg-red-50',
      inactiveText: 'text-gray-700 hover:text-red-700',
      countBg: 'bg-red-100',
      countText: 'text-red-800'
    },
    amber: {
      activeBg: 'bg-gradient-to-r from-amber-500 to-orange-600',
      activeText: 'text-white',
      inactiveBg: 'bg-white hover:bg-amber-50',
      inactiveText: 'text-gray-700 hover:text-amber-700',
      countBg: 'bg-amber-100',
      countText: 'text-amber-800'
    },
    green: {
      activeBg: 'bg-gradient-to-r from-green-500 to-emerald-600',
      activeText: 'text-white',
      inactiveBg: 'bg-white hover:bg-green-50',
      inactiveText: 'text-gray-700 hover:text-green-700',
      countBg: 'bg-green-100',
      countText: 'text-green-800'
    },
    blue: {
      activeBg: 'bg-gradient-to-r from-blue-500 to-sky-600',
      activeText: 'text-white',
      inactiveBg: 'bg-white hover:bg-blue-50',
      inactiveText: 'text-gray-700 hover:text-blue-700',
      countBg: 'bg-blue-100',
      countText: 'text-blue-800'
    },
    gray: {
      activeBg: 'bg-gradient-to-r from-gray-500 to-slate-600',
      activeText: 'text-white',
      inactiveBg: 'bg-white hover:bg-gray-50',
      inactiveText: 'text-gray-700 hover:text-gray-700',
      countBg: 'bg-gray-100',
      countText: 'text-gray-800'
    }
  };
  const colorConfig = colors[color];
  return <button className={`flex items-center justify-between px-4 py-2 rounded-lg border transition-all ${active ? `${colorConfig.activeBg} border-transparent ${colorConfig.activeText} shadow-md` : `${colorConfig.inactiveBg} border-gray-300 ${colorConfig.inactiveText}`}`} onClick={onClick} data-id="element-6978" data-mp="1qgb1bh2oji0b">
      <span className="font-medium" data-id="element-6979" data-mp="1cga0g1mf0aku">{label}</span>
      <span className={`ml-2 inline-flex items-center justify-center h-5 w-5 text-xs rounded-full ${active ? 'bg-white/20 text-white' : `${colorConfig.countBg} ${colorConfig.countText}`}`} data-id="element-6980" data-mp="1chtermoigbjz">
        {count}
      </span>
    </button>;
}
// Helper component for sort options
function SortOption({
  label,
  active,
  onClick
}) {
  return <button className={`w-full text-left px-4 py-2 text-sm ${active ? 'bg-indigo-50 text-indigo-700 font-medium' : 'text-gray-700 hover:bg-gray-50'}`} onClick={onClick} data-id="element-6981" data-mp="xpj4qihpcrcg">
      <div className="flex items-center" data-id="element-6982" data-mp="or7hmqg1obor">
        {active && <CheckIcon size={14} className="mr-2 text-indigo-600" data-id="element-6983" data-mp="e52hlytu9e7o" />}
        <span className={active ? 'ml-0' : 'ml-5'} data-id="element-6984" data-mp="e7op5ygqbtpw">{label}</span>
      </div>
    </button>;
}
// Shopping cart icon component
function ShoppingCartIcon({
  size,
  className
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-6985" data-mp="56gtlo5ll6zi">
      <circle cx="8" cy="21" r="1" data-id="element-6986" data-mp="xuctf1qgrf0i" />
      <circle cx="19" cy="21" r="1" data-id="element-6987" data-mp="11uwswbyieupt" />
      <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" data-id="element-6988" data-mp="11tv7bdjvaptu" />
    </svg>;
}
// Machine Stock Card component
function MachineStockCard({
  machine
}) {
  const statusConfig = {
    Critical: {
      bg: 'bg-gradient-to-r from-red-50 to-rose-100',
      border: 'border-red-200',
      badge: 'bg-gradient-to-r from-red-500 to-rose-600 text-white',
      icon: <AlertCircleIcon size={16} className="mr-1 text-white" data-id="element-6989" data-mp="1lk75vi6vf1k8" />
    },
    Warning: {
      bg: 'bg-gradient-to-r from-amber-50 to-yellow-100',
      border: 'border-amber-200',
      badge: 'bg-gradient-to-r from-amber-500 to-yellow-600 text-white',
      icon: <AlertCircleIcon size={16} className="mr-1 text-white" data-id="element-6990" data-mp="24nr5lhrcd23l" />
    },
    Good: {
      bg: 'bg-gradient-to-r from-blue-50 to-indigo-100',
      border: 'border-blue-200',
      badge: 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white',
      icon: <CheckCircleIcon size={16} className="mr-1 text-white" data-id="element-6991" data-mp="1bzv2nvb6idyd" />
    },
    Optimal: {
      bg: 'bg-gradient-to-r from-green-50 to-emerald-100',
      border: 'border-green-200',
      badge: 'bg-gradient-to-r from-green-500 to-emerald-600 text-white',
      icon: <CheckCircleIcon size={16} className="mr-1 text-white" data-id="element-6992" data-mp="1gyg0jo2ykljn" />
    }
  };
  const priorityConfig = {
    High: {
      bg: 'bg-red-100',
      text: 'text-red-800'
    },
    Medium: {
      bg: 'bg-amber-100',
      text: 'text-amber-800'
    },
    Low: {
      bg: 'bg-blue-100',
      text: 'text-blue-800'
    }
  };
  const trendConfig = {
    increasing: {
      icon: <TrendingUpIcon size={14} className="mr-1 text-green-600" data-id="element-6993" data-mp="qm2xi9h8i9zz" />,
      text: 'text-green-600'
    },
    decreasing: {
      icon: <TrendingDownIcon size={14} className="mr-1 text-red-600" data-id="element-6994" data-mp="zp42g6ud5v22" />,
      text: 'text-red-600'
    },
    stable: {
      icon: <ArrowRightIcon size={14} className="mr-1 text-blue-600" data-id="element-6995" data-mp="14fu5hdfbhltl" />,
      text: 'text-blue-600'
    }
  };
  const config = statusConfig[machine.status];
  const priorityConf = priorityConfig[machine.priority];
  const trendConf = trendConfig[machine.trend];
  return <div className={`rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 ${config.bg} ${config.border}`} data-id="element-6996" data-mp="1efl33nz6cgxw">
      <div className="p-5 relative" data-id="element-6997" data-mp="1neolsqufiubv">
        <div className="flex justify-between items-start mb-3" data-id="element-6998" data-mp="1ndn9kj1og1sk">
          <div data-id="element-6999" data-mp="3k7hywyv4gw7n">
            <div className="flex items-center mb-1" data-id="element-7000" data-mp="3k804wn7l6osr">
              <span className={`px-2.5 py-1 rounded-full text-xs font-medium flex items-center ${config.badge}`} data-id="element-7001" data-mp="3p5jkprjxn9mt">
                {config.icon}
                {machine.status}
              </span>
              <span className={`ml-2 px-2 py-0.5 rounded-full text-xs font-medium ${priorityConf.bg} ${priorityConf.text}`} data-id="element-7002" data-mp="3cvtxid3p1nav">
                {machine.priority} Priority
              </span>
            </div>
            <h3 className="font-bold text-xl text-gray-800" data-id="element-7003" data-mp="32xntnpybu73d">{machine.name}</h3>
            <div className="flex items-center mt-1 text-gray-600 text-sm" data-id="element-7004" data-mp="32vjluwxb4nxt">
              <TagIcon size={14} className="mr-1" data-id="element-7005" data-mp="4ez3ln4vjd8x" />
              {machine.type}
              <span className="mx-2" data-id="element-7006" data-mp="3vncy6da8wp9q">•</span>
              <span className="text-xs bg-gray-100 px-2 py-0.5 rounded-full" data-id="element-7007" data-mp="3qmypqu4qfdb6">
                {machine.id}
              </span>
            </div>
          </div>
          <div className="bg-white/80 backdrop-blur-sm p-2 rounded-lg border border-gray-200 shadow-sm" data-id="element-7008" data-mp="3mktwhwi74ip2">
            <div className="text-center" data-id="element-7009" data-mp="2f94ovkehkcg1">
              <div className="text-xs text-gray-500" data-id="element-7010" data-mp="2b6gc51mnilds">Desired</div>
              <div className="text-lg font-bold text-indigo-700" data-id="element-7011" data-mp="2b8azsnpb4rlk">
                {machine.desiredStock}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-4 space-y-3" data-id="element-7012" data-mp="14zssmkd5819o">
          {Object.entries(machine.stats).map(([key, value]) => {
          if (value === 0) return null;
          const label = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
          let color = 'green';
          if (key === 'lowStock') color = 'yellow';
          if (key === 'overStock') color = 'orange';
          if (key === 'orderRequired') color = 'red';
          return <StockProgressBar key={key} label={label} value={value} color={color} data-id="element-7013" data-mp="1ootg044dg2yx" />;
        })}
        </div>
        <div className="mt-5 grid grid-cols-2 gap-4 text-sm" data-id="element-7014" data-mp="1xn5gqyyych53">
          <div className="bg-white rounded-lg p-3 border border-gray-100 shadow-sm" data-id="element-7015" data-mp="1xnondjj5jj3t">
            <div className="font-medium text-gray-700 mb-1" data-id="element-7016" data-mp="890dboy1ad8y">At hand:</div>
            <div className="text-lg font-bold text-indigo-700" data-id="element-7017" data-mp="39ntld2glmal">
              {machine.atHand}
            </div>
          </div>
          <div className="bg-white rounded-lg p-3 border border-gray-100 shadow-sm" data-id="element-7018" data-mp="2exsnoufun5kn">
            <div className="font-medium text-gray-700 mb-1" data-id="element-7019" data-mp="2juj0n8wcxl1u">Incoming:</div>
            <div className="text-lg font-bold text-teal-600" data-id="element-7020" data-mp="2577ph8438329">
              {machine.incoming}
            </div>
          </div>
        </div>
        <div className="mt-4 flex items-center justify-between" data-id="element-7021" data-mp="2a46ghhsgftw8">
          <div className="text-sm flex items-center" data-id="element-7022" data-mp="1w5qc3xi2efh9">
            <CalendarIcon size={14} className="mr-1 text-gray-500" data-id="element-7023" data-mp="1w82s4549ifro" />
            <span className="text-gray-600" data-id="element-7024" data-mp="215uhardivns6">
              Updated: {machine.lastUpdated}
            </span>
          </div>
          <div className={`text-sm flex items-center ${trendConf.text}`} data-id="element-7025" data-mp="1m9wqzpqa5dnv">
            {trendConf.icon}
            <span data-id="element-7026" data-mp="1r8zn2koa89jp">Trend: {machine.trend}</span>
          </div>
        </div>
        <div className="mt-3 p-3 bg-white/60 backdrop-blur-sm rounded-lg border border-gray-200 text-sm text-gray-700" data-id="element-7027" data-mp="3gmcu4hns4boi">
          <InfoIcon size={14} className="inline-block mr-1 text-indigo-600" data-id="element-7028" data-mp="3litrm2gvc2e9" />
          {machine.forecast}
        </div>
      </div>
      <div className="border-t border-gray-200 p-2 flex justify-between bg-white/60 backdrop-blur-sm" data-id="element-7029" data-mp="3f4xnjanbzzy1">
        <button className="text-indigo-600 hover:text-indigo-800 font-medium flex items-center py-1.5 px-4 rounded-md hover:bg-white transition-colors" data-id="element-7030" data-mp="3a51j5aaq26hy">
          <EyeIcon size={16} className="mr-2" data-id="element-7031" data-mp="365sps6jlgamx" />
          View
        </button>
        <div className="flex" data-id="element-7032" data-mp="6njetcu5rhma">
          <button className="text-gray-600 hover:text-gray-800 font-medium flex items-center py-1.5 px-4 rounded-md hover:bg-white transition-colors" data-id="element-7033" data-mp="6qywmnf7v4re">
            <EditIcon size={16} className="mr-2" data-id="element-7034" data-mp="3t3dun2p3vsgp" />
            Edit
          </button>
          <button className="text-gray-500 hover:text-gray-700 font-medium flex items-center py-1.5 px-3 rounded-md hover:bg-white transition-colors ml-1" data-id="element-7035" data-mp="3p3ddvbejb56h">
            <SettingsIcon size={16} data-id="element-7036" data-mp="phgkadl6za5w" />
          </button>
        </div>
      </div>
    </div>;
}